import styled from 'styled-components';

export const JoinOuterWrap = styled.div(
  props => `
      width: 88%;
      display: flex;
      margin: auto;
      justify-content: center;
      position: relative;
      top: 6rem;
  `,
);

export const JoinInnerWrap = styled.div(
  props => `
      width: 100%;
      height: 12rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l75} ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l60} ;
      border: solid 0 #ffffff;
      box-shadow: 0 0 4px 0 rgba(160, 159, 159, 0.5);
      background: #f0f5ff;
      border-radius: 107px;
      @media only screen and (min-width: 320px) and (max-width: 767px){
        padding: ${props.theme.spacing.large.l20};
        border-radius: 4px;
        height: auto;
      }
      @media only screen and (min-width: 768px) and (max-width: 1024px){
        height: 10rem;
      }
  `,
);

export const FooterInnerWrap = styled.div(
  props => `
    max-width: 1200px;
    margin: 0 auto;
    width:100%;
    display: flex;
    justify-content: center;
    @media only screen and (min-width: 320px) and (max-width: 767px){
      flex-direction: column;
    }
  `
);

export const FooterTextWrapper = styled.p(
  props => `
    align-self: center;
    display: flex;
    font-size: ${props.theme.font.large.font30};
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.black};
    margin-right: ${props.theme.spacing.large.l15};
    @media only screen and (min-width: 320px) and (max-width: 767px){
      font-size: ${props.theme.font.large.font22};
      margin-right: 0;
    }
    @media only screen and (min-width: 768px) and (max-width: 1024px){
      font-size: ${props.theme.font.large.font24};
    }
  `
);

export const SearchBtnWrap = styled.div(
  props => `
    width: 42rem;
    height: 6.5rem;
    display: flex;
    left: 50%;
    align-items: center;
    @media only screen and (min-width: 320px) and (max-width: 767px){
      width:100%;
      padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l15} 0 ${props.theme.spacing.large.l15} ;
      height: auto;
    }
  `
);

export const SearchBtn = styled.button(
  props => `
    width:100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height:5rem;
    background-image: linear-gradient(95deg, #53b2fe 1%, #065af3 130%);
    border-radius: 3.8rem;
    border:none;
    font-size: ${props.theme.font.large.font24};
    color: ${props.theme.colors.white.base};
    font-weight: ${props.theme.font.fontWeight.black};
    outline:none;
    cursor: pointer;
    @media only screen and (min-width: 320px) and (max-width: 767px){
      font-size: ${props.theme.font.large.font18};
    }
  `
);

